<template>
    <div class="form-item-check-sn">
        <label class="check-sn-option">
            <input
                type="checkbox"
                class="check-sn-input"
                :checked="isChecked"
                @change="onChange"
            />

            <span class="check-sn-label">
                {{ item.nmcaption }}
            </span>
        </label>

        <textarea
            v-if="item.ckinformacoes === 'S'"
            class="doc-info"
            placeholder="Informações complementares"
            :value="item.informacoes || ''"
            @input="onInputInformacoes"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:item']);

const isChecked = computed(() => {
    return String(
        props.item.resposta_opcoes_cditem
        ?? props.item.resposta_opcoes
        ?? 'N'
    ).trim().toUpperCase() === 'S';
});

function onChange(event) {
    const value = event.target.checked ? 'S' : 'N';

    emit('update:item', {
        ...props.item,
        resposta_opcoes: value,
        resposta_opcoes_cditem: value
    });
}

function onInputInformacoes(event) {
    emit('update:item', {
        ...props.item,
        informacoes: event.target.value || null
    });
}
</script>

<style scoped>
.form-item-check-sn {
    min-width: 0;
}

.check-sn-option {
    display: inline-flex;
    align-items: flex-start;
    gap: 7px;

    max-width: 100%;
    padding: 7px 10px;

    border: 1px solid #d0d0d0;
    border-radius: 4px;
    background: #f9f9f9;

    font-weight: normal;
    line-height: 1.25;
    cursor: pointer;

    transition: 0.15s;
}

.check-sn-option:hover {
    background: #eef5f4;
    border-color: #4a827c;
}

.check-sn-option:has(.check-sn-input:checked) {
    background: #dff1ef;
    border-color: #4a827c;
    box-shadow: inset 0 0 0 1px #4a827c;
}

.check-sn-input {
    width: 15px !important;
    height: 15px !important;
    min-height: 15px !important;

    flex: 0 0 15px;

    padding: 0;
    margin: 1px 0 0;
    cursor: pointer;
}

.check-sn-label {
    display: inline-block;
    max-width: 100%;
    word-break: break-word;
}

.doc-info {
    display: block;
    width: 100%;
    min-height: 70px;
    margin-top: 8px;
    resize: vertical;
}
</style>
